import { getDefaultExportFromCjs as i } from "./ghl-ui.es417.js";
import { __module as o } from "./ghl-ui.es1642.js";
(function(n, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  function l(e) {
    var s = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
    return s.setUTCFullYear(e.getFullYear()), e.getTime() - s.getTime();
  }
  n.exports = t.default;
})(o, o.exports);
var r = o.exports;
const g = /* @__PURE__ */ i(r);
export {
  g as default,
  r as g
};
